"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function quote(value, single) {
    if (single === void 0) { single = false; }
    var quoteChar = single ? "'" : "\"";
    if (value === null || value === undefined) {
        return '';
    }
    else if (typeof value === 'string') {
        return "".concat(quoteChar).concat(value).concat(quoteChar);
    }
    else if (typeof value === 'number') {
        return "".concat(value);
    }
    else if (value instanceof Date) {
        return "".concat(quoteChar).concat(value.toISOString()).concat(quoteChar);
    }
    else {
        return value.map(function (x) { return quote(x); });
    }
}
exports.default = {
    quote: quote,
};
